/**
 * Global state for the Deep Focus mode.
 *
 * Distinct from ContextBarAppearanceContext: this store answers "is the user
 * currently in Deep Focus mode?" — a global, functional question. It drives
 * cross-cutting behaviour that lives outside any single component subtree:
 * activating/deactivating the mode (DeepFocusSelect), pausing music on exit
 * (DiskJockey), resetting the mode on navigation (DashboardLayout), and
 * adjusting input focus targets (EmailView).
 *
 * Do not use this store for widget styling inside ContextBar — use
 * ContextBarAppearanceContext instead, which is scoped to the rendering layout.
 */
import { setSettingsDialogOpen } from "@/stores/settingsStore";
import { Store } from "@tanstack/react-store";

const deepFocusStore = new Store({
    isActive: false,
});

export const setDeepFocusActive = (isActive: boolean) => {
    if (isActive) {
        // DeepFocusOverlay portals to <body>; closing the Settings dialog
        // first avoids being caught by its Radix scroll lock.
        setSettingsDialogOpen(false);
    }

    deepFocusStore.setState(() => ({ isActive }));
};

export default deepFocusStore;
